module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-09-19 at 4.38.05 PM.2fb2e9e0.jpeg";